import React from 'react';
import { CategorySelector } from 'shared/category-selector';
import { SortingSelector } from 'shared/sorting-selector';
import { Pagination } from 'shared/pagination';
import ProductListCards from './product-list-cards';
import ProductListSkeleton from './product-list-skeleton';

class ProductListLayout extends React.PureComponent {
    render() {
        return (
            <>
                {this.props.showTitleFlag &&
                    <h2 className="product-list__title heading-3">All products</h2>
                }
                <div className="product-list__filters">
                    <div className="product-list__category">
                        <div className="product-list__category-label">
                            Filter: <span className="visually-hidden">by categories</span>
                        </div>
                        <CategorySelector
                            childCss="product-list__category-selector"
                            categories={this.props.categories}
                            selectedCategories={this.props.selectedCategories}
                            onApply={this.props.selectCategories}
                        />
                    </div>
                    <div className="product-list__sorting">
                        <div className="product-list__sorting-label">
                            Sort by: <span className="visually-hidden">{this.props.sorting.title}</span>
                        </div>
                        <SortingSelector
                            sortTypes={this.props.sortTypes}
                            selectedSortType={this.props.sorting}
                            onSelect={this.props.selectSorting}
                        />
                    </div>
                </div>
                <div className="product-list__cards" tabIndex={0}>
                    {this.props.isLoading && (
                        <ProductListSkeleton />
                    )}
                    {!this.props.isLoading && (
                        <ProductListCards products={this.props.products} />
                    )}
                </div>
                <div className="product-list__pagination">
                    <Pagination
                        pager={this.props.pager}
                        onSelectPage={this.props.selectPage}
                    />
                </div>
            </>
        );
    }
}

export default ProductListLayout;
